import Image from "next/image";
import clsx from "clsx";

type SubpageBackgroundProps = {
  className?: string;
  /** Background image source. Defaults to the shared angular subpage pattern. */
  src?: string;
  /** Intrinsic width/height — set to the asset's true aspect ratio to avoid stretching. */
  width?: number;
  height?: number;
  /**
   * If true, background image is requested earlier.
   * Use sparingly: decorative backgrounds should generally NOT be LCP.
   */
  priority?: boolean;
};

/**
 * Shared decorative background.
 *
 * Why: replaces raw `<img>` with `next/image` to avoid CLS and allow modern formats/caching.
 * Accessibility: decorative backgrounds should have empty alt and be aria-hidden.
 */
export default function SubpageBackground({
  className,
  src = "/images/subpage-background.svg",
  width = 1920,
  height = 1080,
  priority = false,
}: SubpageBackgroundProps) {
  return (
    <div aria-hidden="true" className={clsx("absolute top-0 left-0 w-full pointer-events-none z-0", className)}>
      <Image
        src={src}
        alt=""
        width={width}
        height={height}
        sizes="100vw"
        className="w-full h-auto"
        priority={priority}
      />
    </div>
  );
}

